import { useContext, useEffect } from "react";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import TablaSolicitudEnviada from "./SolicitudEnviada/TablaSolicitudEnviada";
import TablaSolicitudRecibida from "./SolicitudRecibida/TablaSolicitudRecibida";
import "../../../../assets/Seleccion/registro-traspaso-responsive.css";

const TablaRegistroTraspaso = () => {
  const {
    toasts, 
    getListaGeneral, 
    getExclusiones,
    getToken,
    token,
  } = useContext(SeleccionContext);

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token) {
      getListaGeneral({token});
      getExclusiones({token});
    }
  }, [token]);

  return (
    <>
      {toasts}
      <TablaSolicitudEnviada />
      <TablaSolicitudRecibida />
    </>
  );
};

export default TablaRegistroTraspaso;
